<template>
  <tr class="row-details">
    <td colspan="6" class="v-align-top" style="background-color: #efefef;">
      <h5>Détails commande</h5>
      <table class="table table-striped table-condensed m-t-0 m-b-0">
        <thead>
          <tr>
            <th>Libellé</th>
            <th class="text-center">Prix unitaire</th>
            <th class="text-center">Quantité</th>
            <th class="text-center">Unité</th>
            <th class="text-center">Saisie libre</th>
            <th class="text-right">Prix total</th>
          </tr>
        </thead>
        <tbody>
          <!-- Suborders -->
          <template v-for="suborder in order.suborders">
            <tr>
              <td class="suborder-text">
                <div>{{ suborder.text }}</div>
                <div class="text-complement">
                  <div>
                    <dt>Agence :</dt>
                    <dd>{{ suborder.offer.distributed_product.agency.name }}</dd>
                  </div>
                  <div v-if="suborder.offer.distribution_method.booking">
                    <dt>Période :</dt>
                    <dd>{{ suborder.booking_start_date | moment-booking-date }} - {{ suborder.booking_end_date | moment-booking-date }}</dd>
                  </div>
                </div>
              </td>
              <td class="text-center">{{ formattedUnitPrice(suborder.price, suborder.quantity) }}€</td>
              <td class="text-center">{{ suborder.quantity }}</td>
              <td class="text-center">{{ capitalizeFirstLetter(suborder.decoded_unit) }}</td>
              <td class="text-center">{{ formattedFreePrice(suborder.free_price) }}</td>
              <td class="text-right">{{ formattedPrice(suborder.price) }}€</td>
            </tr>
            
            <!-- Suborder supplemental lines -->
            <tr v-for="supplementalLine in suborder.supplemental_lines" class="text-muted">
              <td colspan="5"><em>{{ supplementalLine.text }}</em></td>
              <td class="text-right"><em>{{ formattedPrice(supplementalLine.price) }}€</em></td>
            </tr>
            <!-- Suborder supplemental lines: end -->

            <!-- Suborder supplemental price conditions -->
            <tr v-for="supplementalPriceCondition in suborder.supplemental_price_conditions" class="text-muted">
              <td colspan="5">
                <em>
                  {{ supplementalPriceCondition.decoded_type }}
                  <template v-if="'percentage' == supplementalPriceCondition.base_type">{{ supplementalPriceCondition.base_value / 100 }}%</template>
                </em>
              </td>
              <td class="text-right"><em>{{ formattedPrice(supplementalPriceCondition.computed_price) }}€</em></td>
            </tr>
            <!-- Suborder supplemental price conditions: end -->

            <!-- Suborder options -->
            <template v-for="suborderOption in suborder.suborder_options">
              <tr>
                <td>{{ suborderOption.text }}</td>
                <td class="text-center">{{ formattedUnitPrice(suborderOption.price, suborder.quantity) }}€</td>
                <td class="text-center">{{ suborderOption.quantity }}</td>
                <td class="text-center">{{ capitalizeFirstLetter(suborderOption.decoded_unit) }}</td>
                <td class="text-center">{{ formattedFreePrice(suborderOption.free_price) }}</td>
                <td class="text-right">{{ formattedPrice(suborderOption.price) }}€</td>
              </tr>
            
              <!-- Option Supplemental lines -->
              <tr v-for="supplementalLine in suborderOption.supplemental_lines" class="text-muted">
                <td colspan="5"><em>{{ supplementalLine.text }}</em></td>
                <td class="text-right"><em>{{ formattedPrice(supplementalLine.price) }}€</em></td>
              </tr>
              <!-- Option Supplemental lines: end -->
                
              <!-- Option supplemental price conditions -->
              <tr v-for="supplementalPriceCondition in suborderOption.supplemental_price_conditions" class="text-muted">
                <td colspan="5">
                  <em>
                    {{ supplementalPriceCondition.decoded_type }}
                    <template v-if="'percentage' == supplementalPriceCondition.base_type">{{ supplementalPriceCondition.base_value / 100 }}%</template>
                  </em>
                </td>
                <td class="text-right"><em>{{ formattedPrice(supplementalPriceCondition.computed_price) }}€</em></td>
              </tr>
              <!-- Option supplemental price conditions: end -->
            </template>
            <!-- Suborder options: end -->
          </template>
          <!-- Suborders: end -->
          <tr>
            <td colspan="5">Total HT</td>
            <td class="text-right">{{ formattedPrice(order.total_ht) }}€</td>
          </tr>
          <tr>
            <td colspan="5">TVA {{ order.tax_rate * 100 }}%</td>
            <td class="text-right">{{ formattedPrice(order.tax_amount) }}€</td>
          </tr>
          <tr>
            <td colspan="5"><b>Total TTC</b></td>
            <td class="text-right"><b>{{ formattedPrice(order.total_ttc) }}€</b></td>
          </tr>
          <tr v-if="order.deposit_amount > 0">
            <td colspan="5"><b>Total dépôts de garantie</b></td>
            <td class="text-right"><b>{{ formattedPrice(order.deposit_amount) }}€</b></td>
          </tr>
          <tr>
            <td colspan="5"><b>Total à régler</b></td>
            <td class="text-right"><b>{{ formattedPrice(order.total_to_pay) }}€</b></td>
          </tr>
        </tbody>
      </table>
    </td>
    <td colspan="3" class="v-align-top" style="background-color: #efefef;">
      <h5>Détails paiement</h5>
      <div>
        <div class="payment-status">{{ order.decoded_payment_status }}</div>
        <template v-if="order.payments && order.payments.length > 0">
          <payment-item 
            v-for="(payment, idx) in order.payments" 
            :key="'payment-' + idx"
            :payment="payment"
            :details="true">
          </payment-item>
        </template>
      </div>
    </td>
  </tr>
</template>

<script>
  import PaymentItem from '../../Payment/Item'

  export default {
    name:"ItemDetails",

    props:["order"],

    components: {
      PaymentItem
    },

    methods:{
      formattedPrice(basePrice)
      {
        return (basePrice / 100).toFixed(2)
      },

      formattedUnitPrice(basePrice, quantity)
      {
        return (this.formattedPrice(basePrice) / quantity).toFixed(2)
      },

      formattedFreePrice(freePrice)
      {
        return freePrice ? 'Oui' : 'Non'
      },

      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .suborder-text {
    .text-complement { 
      font-size: 12px;
    }
  }

  .payment-status { font-weight: bold; }
</style>



// WEBPACK FOOTER //
// client/components/Customer/OrdersTabContent/ItemDetails.vue